import { getSkillChatURL as getCanonicalSkillChatURL } from '#pplx/frontend/apps/ask/skills/chat-actions/getSkillChatURL.js';
export const getSkillChatURL = getCanonicalSkillChatURL;
//# sourceMappingURL=getSkillChatURL.js.map